import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Integumentary () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>

      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.integumentaryRashes.name}
            options={[
              {
                label: 'No Rashes',
                value: 'No Rashes'
              },
              {
                label: 'Rashes',
                value: 'Rashes'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.integumentaryLesions.name}
            options={[
              {
                label: 'No Lesions',
                value: 'No Lesions'
              },
              {
                label: 'Lesions',
                value: 'Lesions'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.integumentaryJaundice.name}
            options={[
              {
                label: 'No Jaundice',
                value: 'No Jaundice'
              },
              {
                label: 'Jaundice',
                value: 'Jaundice'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.integumentaryOther} />
        </div>
      </div>

      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.integumentaryOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Integumentary
